import React from 'react';
import { MdCheckCircle } from 'react-icons/md';

interface PayLaterSuccessPopupProps {
  isOpen: boolean;
  onClose?: () => void;
  onContinue: () => void;
}

export const PayLaterSuccessPopup: React.FC<PayLaterSuccessPopupProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4">
      <div className="bg-white/90 rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all ring-1 ring-white/20">
        <div className="p-6 text-center">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4 shadow-md">
            <MdCheckCircle className="h-8 w-8 text-green-600" aria-hidden="true" />
          </div>

          {/* Title */}
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Order Placed Successfully!
          </h3>

          {/* Message */}
          <p className="text-gray-600 mb-6">
            Your order has been placed successfully. Thank you for your order!
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              type="button"
              onClick={onContinue}
              className="bg-green-500 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-600 transition-colors focus:outline-none"
            >
              Continue Shopping
            </button>
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="bg-gray-200 text-gray-800 py-3 px-6 rounded-lg font-semibold hover:bg-gray-300 transition-colors focus:outline-none"
              >
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
